import { useMembers } from "../contexts/members";

export const useIsMemberCovered = (coverageType: "dental" | "vision") => {
    const { hasCoverage, isMember } = useMembers();

    return isMember && hasCoverage(coverageType);
};
